import { z } from 'zod';
import { errorMap } from 'zod-validation-error';

import { deepCopy, getErrorKeys, removeKeysFromObject } from '../optionsSchemaUtils';
import { RecipientFieldsElementOptions } from './RecipientFieldsElement';

const DISPLAY_MODES = ['full-screen', 'container'] as const;

export const RecipientFieldsOptionsSchema = z.object({
  recipientId: z.string().trim().min(1),
  displayMode: z.enum(DISPLAY_MODES).optional()
});

export const parseRecipientFieldsOptions = (options: RecipientFieldsElementOptions) => {
  const mandatoryResult = RecipientFieldsOptionsSchema.safeParse(options, { errorMap });
  const initialOptions = deepCopy(options);

  if (!mandatoryResult.success && mandatoryResult.error.flatten().fieldErrors['recipientId']) {
    return { errors: mandatoryResult.error.errors };
  }

  const errorKeys = getErrorKeys(mandatoryResult.error?.errors || []);
  const sanitizedOptions = removeKeysFromObject(options, errorKeys);

  return !mandatoryResult.success
    ? {
        warnings: mandatoryResult.error.flatten().fieldErrors,
        options: sanitizedOptions as RecipientFieldsElementOptions,
        initialOptions
      }
    : {
        options: mandatoryResult.data as RecipientFieldsElementOptions,
        initialOptions
      };
};
